import { prepareMetaPixel, configureMetaPixel, trackMetaEvent } from '../utils/metaPixel'
import { reportDeposits } from '../utils/reportDeposits'
/*eslint-disable*/
import * as types from './mutation-types';
import $Cookies from 'js-cookie';
import { common, commonApi } from '@/common/index';
import { Message } from 'element-ui';
import $qs from 'qs';
import { queryListBuried , updateBuried , inviteInfo} from '@/common/api/bindAuthenticate.js'


export const setIndexNav = function({commit, state},index) {
  commit(types.SET_NAV_INDEX,index)
};
export const setMineIndexNav = function({commit, state},index) {
  commit(types.SET_MINE_NAV_INDEX,index)
};
export const setSlotsIndexNav = function({commit, state},index) {
  commit(types.SET_SLOTS_NAV_INDEX,index)
};
export const setCapitalIndexNav = function({commit, state},index) {
  commit(types.SET_MINE_CAPITAL_NAV,index)
};
export const setHelpIndexNav = function({commit, state},index) {
  commit(types.SET_HELP_CAPITAL_NAV,index)
};

// 各游戏平台
export const gameListByPlatform = function ({commit, state}, obj) {
  commit(types.GAME_LIST_BY_PLATFORM, obj)
}

// 老虎机游戏图片链接
export const setSlotPic = function ({commit, state}, picLink) {
  commit(types.SET_SLOT_PIC,picLink)
}

// 一级导航
export const getFirstNav = function ({commit, state}) {
  commonApi.HOMEBEFORE.getFirstNav()
    .then((list) => {
      commit(types.SET_FIRST_NAV, list)
    })
    .catch((err)=> {})
}

export const Login = function ({commit, state}, UUID) {
  commit(types.LOGIN,UUID)
};

export const checkLogin = function ({commit, state}) {
  let url = window.location.href;
  let UUID = $qs.parse(url.split('?')[1]).UUID;
  // console.log('ooo')
  if (UUID === undefined) {
    UUID = $Cookies.get('UUID')
  } else {
    $Cookies.set('UUID', UUID)
  }
  let obj = {};
  if(UUID) {
    obj['isLogin'] = true;
    obj['UUID'] = UUID;
    commit(types.CHECK_LOGIN, obj)
  }else {
    commit(types.LOGIN_OUT)
  }
};
// 用户信息
export const getFirstInfo = function({commit, state, dispatch}){
  commonApi.USER.getUserInfo()
    .then((data)=>{
      commit(types.SET_USER_INFO,data)
      // 首存查询
      if($Cookies.get('UUID')){

        dispatch('reportDepositEvents')

        inviteInfo({UUID: $Cookies.get('UUID')}).then(([data, err]) => {
          if (!err) {
            const { buttonDisplay , buttonStatus , claimedBonus } = data
            commit('setInviteInfo', {claimedBonus,buttonStatus,buttonDisplay})
          }
        })

      }
    })
    .catch((err)=>{
      if(err === 998){
        commit('SET_FORCE_CHANGE_PASSWORD', true);
      }else{
        Message.warning(err)
      }
    })
};
function loadJsCode(code){
  let script = document.createElement('script');
  script.type = 'text/javascript';
  //for Chrome Firefox Opera Safari
  script.appendChild(document.createTextNode(code));
  //for IE
  //script.text = code;
  document.head.appendChild(script);
}
function loadnoscript(iframeSrc){
  let noscript = document.createElement('noscript');
  let iframe  = document.createElement('iframe');
  iframe.src  = iframeSrc;
  iframe.height = 1;
  iframe.width = 1;
  iframe.style = 'display:none';
  noscript.appendChild(iframe)
  document.body.appendChild(noscript);
}
// 获取链接列表
let initRequest = null
let initParamsKey = ''
let initVersion = 0
export const initLinkList = function ({commit, state}) {
  // 请求前同步读取 URL / Cookie，不依赖路由守卫的执行时机。
  const params = {
    agentCode: common.getAgentCode(),
    pageUrl: window.location.origin
  }
  const requestKey = JSON.stringify(params)
  if (initRequest && initParamsKey === requestKey) return initRequest
  initParamsKey = requestKey
  const version = ++initVersion
  prepareMetaPixel()
  initRequest = commonApi.HOMEBEFORE.initLink(params)
    .then((data)=>{
      if (version !== initVersion) return null
      commit(types.INIT_LIST,data)
      data.isNameVerify == '1'?commit('setIsNameVerify',true):commit('setIsNameVerify',false)
      data.isPhoneVerify == '1'?commit('setIsPhoneVerify',true):commit('setIsPhoneVerify',false)
      data.isMailVerify == '1'?commit('setIsMailVerify',true):commit('setIsMailVerify',false)
      configureMetaPixel(data.pageBuryingId)
      if(!!data.googleType && !!data.googleId){
        if(data.googleType == 10){//gtag
          window.onload=function(){
            let script = document.createElement('script');
            script.type = 'text/javascript';
            script.src  = 'https://www.googletagmanager.com/gtag/js?id='+data.googleId;
            script.async ='async'
            script.appendChild(document.createTextNode(code));
            document.head.appendChild(script);
          }
          loadJsCode(`window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
        
          gtag('config', ${data.googleId});`);
        }else if(data.googleType == 20){//gtm
          window.onload=function(){
            loadnoscript('https://www.googletagmanager.com/ns.html?id='+data.googleId)
          }
          loadJsCode(`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${data.googleId}');`);
        }
      }
      if(data.sharechatId){
        loadJsCode(`(function (w, d, s, l, i) {
          w['scSdkId'] = i;
          w[l] = w[l]  []
          w.scq = function (eventName, eventType, p) {
          var props = p  {}
            w[l].push({ eventName: eventName, eventType: eventType, meta: props, eventFireTs: Date.now() })
          };
          w.scq("PAGE_VIEW", "AUTO", {
            pageUrl: w.location.href
          });
          var scr = d.createElement(s);
          scr.type = 'text/javascript';
          scr.async = true;
          scr.src = 'https://sc-events-sdk.sharechat.com/web-sdk.js';
          var x = d.getElementsByTagName(s)[0];
          x.parentNode.insertBefore(scr, x);
        })(window, document, "script", "scLayer", ${data.sharechatId});`);
      }
      if(!!data.snapPixelId){
        loadJsCode(`(function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function()
          {a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};
          a.queue=[];var s='script';r=t.createElement(s);r.async=!0;
          r.src=n;var u=t.getElementsByTagName(s)[0];
          u.parentNode.insertBefore(r,u);})(window,document,
          'https://sc-static.net/scevent.min.js');
          
          snaptr('init', '${data.snapPixelId}', {
          'user_email': 'INSERT_USER_EMAIL'
          });
          
          snaptr('track', 'PAGE_VIEW');`);
      }
      return data
    })
    .catch((err)=>{
      if (version !== initVersion) return null
      initRequest = null
      Message.warning(err)
      return null
    })
  return initRequest
};

// 获取新链接列表
export const newinitLinkList = function ({commit, state}) {
  commonApi.HOMEAFTER.getFrontConfigList()
    .then((data)=>{
      commit(types.FRONTCONFIG_LIST,data)
      // data.isNameVerify == '1'?commit('setIsNameVerify',true):commit('setIsNameVerify',false)
    })
    .catch((err)=>{
      Message.warning(err)
    })
};

// 获取维护游戏的列表
export const maintainGameList = function ({commit, state}) {
  commonApi.HOMEBEFORE.allGameInfo()
    .then(data => {
      let list = data.filter(item => item.maintain === '1');
      commit(types.SET_MAINTAIN_GAME_LIST, list)
    })
    .catch(err=>{})
};
// 设置维护信息
export const maintainGameInfo = function ({commit, state},info) {
  commit(types.SET_MAINTAIN_GAME_INFO,info)
}
// 设置维护信息状态
export const maintainGameState = function ({commit, state},boolean) {
  commit(types.SET_MAINTAIN_GAME_STATE,boolean)
}
// 设置站内信条数
export const getInEmail = function({commit, state}){
  let params = {
    UUID:state.UUID,
    pageNo:1,
    pageSize:10,
    read: 0
  }
  commonApi.VIP.getMsgSiteList(params)
  .then(data=>{
    commit(types.SET_INEMAIL,data.total)
  })
  .catch(err=>{
    commit(types.SET_INEMAIL,0)
  })

}

// 获取文章列表
export const getArticleType = function ({commit, state}) {
  commonApi.HELP.getArticleType()
    .then(data=>{
      commit('set_downNav', data)
    })
    .catch(err=>{})
}

/**
 * 多彩宝 */
// 奖池金额
export const addJackPotMoney = function ({commit}) {

  let num = Math.random()*15;
  let moneyNum = parseFloat(num.toFixed(2));

  commit(types.ADD_COLOR_STARTMONEY,moneyNum)
};

export const getColorService = function ({commit}) {
  commonApi.HOMEBEFORE.service()
    .then(customerUrl => {
      customerUrl && commit(types.SET_COLOR_SERVICE,customerUrl)
    })
    .catch(err => {})
}

/**
 * 金色*/
export const setArticleTypeList = function ({commit, state}, list) {
  commit(types.SET_ARTICLETYPELIST,list)
};

/**
 * 金沙 */
export const JIN_SHA_GLOBAL_LOGIN = function ({commit, state}, bool) {
  commit(types.JIN_SHA_GLOBAL_LOGIN,bool)
};

export const BEFORE_LOGIN_GAME_INFO = function ({commit, state}, obj) {
  commit(types.BEFORE_LOGIN_GAME_INFO,obj)
};

export const IS_LOGIN_FOCUS = function ({commit, state}, bool) {
  commit(types.IS_LOGIN_FOCUS,bool)
};

/**
 * 体育*/

export const sports_setTopNav = function ({commit, state},bool) {
  commit(types.SPORTS_SET_TOP_NAV,bool)
}

export const set_spots_nav_index = function ({commit, state}, index) {
  commit(types.SET_SPORTS_NAV_INDEX, index)
}

export const set_is_register_success = function ({commit, state}, boolean) {
  commit(types.SET_IS_REGISTER_SUCCESS, boolean)
}

// 新优惠
export const getBonusInfo = function({commit,state}){
  // 获取优惠类型
  commonApi.DISCOUNTS.queryBonusArticleTypeList()
  .then(data =>{
    commit(types.SETBONUSTYPES,data)
    // 获取优惠
    let param = {
      typeId:state.BonusTypes[0].articleId,
      platform:'pc',
      pageNo: 1,
      pageSize: 200,
    }
    commonApi.DISCOUNTS.queryBonusArticleInfoList(param)
    .then(data =>{

      data.list && commit('setAllBonusArticle',data.list)

    })
  })
}
// 新优惠（02B,03B）
export const getBonusInfo_ = function({commit,state}){
  // 获取优惠类型
  commonApi.DISCOUNTS.queryBonusArticleTypeList()
  .then(data =>{
    commit(types.SETBONUSTYPES,data)
    //获取优惠
    // let param = {
    //   typeId:state.BonusTypes[0].articleId,
    //   platform:'pc',
    //   pageNo: 1,
    //   pageSize: 200,
    // }
    // commonApi.DISCOUNTS.queryBonusArticleInfoList(param)
    // .then(data =>{

    //   data.list && commit('setAllBonusArticle',data.list)

    // })
  })
}

// Configuration must arrive before consuming the backend reporting flags.
export const reportDepositEvents = function ({ dispatch, state }) {
  const UUID = $Cookies.get('UUID')
  if (!UUID) return
  return dispatch('initLinkList').then(config => {
    if (!config || $Cookies.get('UUID') !== UUID) return
    return reportDeposits({ UUID, config, query: queryListBuried, update: updateBuried, app: false })
  })
}

export const reportRegistration = function ({ dispatch }) {
  dispatch('initLinkList')
  return trackMetaEvent('CompleteRegistration')
}



// WEBPACK FOOTER //
// ./src/common/store/actions.js